import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import SetListForm from "../../components/setList/SetListForm";
import { Button, Grid, Typography, FormControlLabel, Checkbox, TextField, Collapse, Divider } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SettingsIcon from "@material-ui/icons/Settings";
import AddIcon from "@material-ui/icons/Add";
import CheckIcon from "@material-ui/icons/Check";
import EmailIcon from "@material-ui/icons/Email";
import PrintIcon from "@material-ui/icons/Print";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GetAppIcon from "@material-ui/icons/GetApp";
import InputAdornment from "@material-ui/core/InputAdornment";
import blankProfile from "../../img/hotgig-loading.png";
import { ProfileType } from "../../types/enum";
import MainContainer from "../../components/MainContainer";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import Breadcrumb from "../../components/Breadcrumb";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor"
import "./Booking.css";
import moment from "moment";
import { Paper, Hidden } from "@material-ui/core";
import PdfViewer from "../../components/pdf/PdfViewer";
import MultiInputTextbox from './MultiInputTextbox';
import blankBackground from "../../img/hero2.jpg";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import BookingDetailsModal from "../../components/booking/DocumentModal/BookingDetailsModal.js";
import Heading from "../../components/Heading";
import MultiInputTextboxReplyTo from './MultiInputTextboxReplyTo';
import Loading from "../../components/loadingSpinner/Loading";
const BOOKING_STATUS = [
    "New",
    "Declined",
    "Negotiate",
    "Accepted",
    "LineupSet",
    "SetlistSet",
    "Ready",
    "Completed",
    "Paid",
    "Cancelled",
    "Resent",
    "Draft",
    "Incomplete",
    "Cancelled By Act",
    "Cancelled By Act",
    "SentToAct",
    "PlayerNotified",
    "PlayerDeclined",
    "AllPlayerConfirmed",
    "ClientNotified",
    "PlayerInvitedAndClientNotified",
    "PlayerConfirmedAndClientNotified"
];

@inject("templateStore", "bookingRequestStore", "profileStore", "userStore", "sendBookingDetailsStore")
@observer
class SendBookingDetailsComponent extends Component {
    state = {
        isLoading: false,
        clientMessage: "",
        pdfFile: "",
        to:[],
        image: null,
        openDetails: false,
        sendFeeDetails: true,
        replyTo:[],
        subject: "",
        pdfOptionsExpanded: true,
        pdfOptions: {
            includeActPhone: true,
            includeActEmail: false,
            includeActAddress: false,
            includeFeeDetails: true,
            includeVenueContract: true,
            includeAgencyContract: false
        },
        activePreset: "venue",
        pdfOptionsDirty: false,
        recipientsExpanded: false,
        mobilePreviewExpanded: false
    };
    
    breadcrumb = [{ name: "Dashboard", link: "/" }, { name: "Send Booking Details" }];

    componentDidMount() {
        const { currentUser } = this.props.userStore;
       
        var currentProfile = this.props.profileStore.getCurrentProfile()
        
        this.setState({
            ...this.state,
            isLoading:true
        })
        
        const imageProfileId = currentProfile?.type === ProfileType.Agent.ordinal && currentProfile?.myAgencies?.length > 0
            ? currentProfile.myAgencies[0].agentId
            : currentProfile?.id;

        Promise.all(
            [this.props.profileStore.getAllImageById(imageProfileId),
                this.props.bookingRequestStore.downloadBookinDetailsPdf(this.props.bookingId, this.state.sendFeeDetails, this.state.pdfOptions),
                this.props.bookingRequestStore.initializeEditBooking(this.props.bookingId),
                this.props.sendBookingDetailsStore.getByProfileIdBookingId(currentProfile?.id, this.props.bookingId)
            ]).then(response => {
                const { booking } = this.props.bookingRequestStore;
                var responseFile = response[1]
                var history = response[3]
                let pdfFile = `data:application/pdf;base64,${responseFile}`;
                if(history){
                    var emailAddress = []
                    if(history.emailAddress){
                        emailAddress = history.emailAddress.split(",");
                    }
                    var lc = history.subject
                    var isUpdated = lc.indexOf("Updated") > 0
                    var subject = isUpdated ? history.subject : `[Updated] ${history.subject}`
                    this.setState({
                        ...this.state,
                        pdfFile: pdfFile,
                        image: response[0],
                        isLoading: false,
                        replyTo: [history.replyTo],
                        to: emailAddress?.length ? emailAddress : [],
                        clientMessage: history.message,
                        subject: subject
                    });
                }else{
                    var step = this.props.step
                    this.setState({
                        ...this.state,
                        pdfFile: pdfFile,
                        image: response[0],
                        isLoading: false,
                        to: booking?.venue?.email? [booking?.venue?.email] : [],
                        replyTo: [currentUser.email],
                        subject: step === "sendBookingEmailReturn" ? `[Updated] Booking Details for ${booking?.title} - ${moment(booking.dateStart).format("ddd, DD-MM-YYYY")}`:  `Booking Details for ${booking?.title} - ${moment(booking.dateStart).format("ddd, DD-MM-YYYY")}`
                    });
                }
            })
    }
    

    handleChangeBody = (e) => {
        this.setState({
            ...this.state,
            clientMessage: e
        });
    };

    handleSubmitForm = () => {
        var data = {
            emailAddress: this.state.to.toString(),
            bookingId: this.props.bookingId,
            emailBody: this.state.clientMessage,
            sendFeeDetails: this.state.sendFeeDetails,
            pdfOptions: this.state.pdfOptions,
            replyTo: this.state.replyTo.toString(),
            subject: this.state.subject
        }
        this.setState({
            ...this.state,
            isLoading:true
        })
        this.props.bookingRequestStore.sendBookingDetailsToEmail(data).then(responseFile => {
            this.setState({
                ...this.state,
                isLoading:false
            })
            this.props.templateStore.openSnackbar("Email sent!");
            // if(this.props.previousPage == 2){
            //     this.props.history.push("/musician/gig/upcoming")
            // }else if(this.props.previousPage == 1){
            //     this.props.history.push("/musician/gig/request")
                
            // }else if(this.props.previousPage == 0){
            //     this.props.history.push("/musician/gig/drafts")
                
            // }else if(this.props.previousPage == 3){
            //     this.props.history.push("/musician/gig/completed")
                
            // }
            // else if(this.props.previousPage == 4){
            //     this.props.history.push("/musician/gig/cancelled")  
            // }
            // else{
            //     this.props.history.push("/musician/gig/all")
                
            // }
        }).catch((err) => {
            this.props.templateStore.openSnackbar("Failed to send email, try again later or contact administrator");
        })
        
    }

    checkSendFeedDetails = (checked) => {
        const updatedOptions = {
            ...this.state.pdfOptions,
            includeFeeDetails: checked
        };
        this.setState({ isLoading: true, pdfOptions: updatedOptions, sendFeeDetails: checked });
        this.props.bookingRequestStore.downloadBookinDetailsPdf(this.props.bookingId, checked, updatedOptions)
            .then(responseFile => {
            let pdfFile = `data:application/pdf;base64,${responseFile}`;
            this.setState({
                ...this.state,
                pdfFile: pdfFile,
                isLoading: false
            });
        });
    }

    setData = (newInputs) => {
        this.setState({
            ...this.state,
            to: newInputs
        });
    }

    handleInputChangeSubject = (event) => {
        const value = event.target.value;

        this.setState({
            ...this.state,
            subject: value
        });
    }
    setReplyTo= (newInputs) => {
        this.setState({
            ...this.state,
            replyTo: newInputs
        });
    }
    getReplyTo= () => {
        return this.state.replyTo
    }

    togglePdfOptions = () => {
        this.setState({
            pdfOptionsExpanded: !this.state.pdfOptionsExpanded
        });
    }

    handlePdfOptionChange = (optionName) => (e) => {
        const newOptions = {
            ...this.state.pdfOptions,
            [optionName]: e.target.checked
        };
        
        if (optionName === 'includeFeeDetails') {
            this.setState({ 
                pdfOptions: newOptions,
                sendFeeDetails: e.target.checked,
                pdfOptionsDirty: true
            });
        } else {
            this.setState({ 
                pdfOptions: newOptions,
                activePreset: null,
                pdfOptionsDirty: true
            });
        }
    }

    refreshPdfWithOptions = (options) => {
        this.setState({ isLoading: true });
        this.props.bookingRequestStore.downloadBookinDetailsPdf(this.props.bookingId, options.includeFeeDetails, options)
            .then(responseFile => {
                let pdfFile = `data:application/pdf;base64,${responseFile}`;
                this.setState({
                    pdfFile: pdfFile,
                    isLoading: false,
                    pdfOptionsDirty: false
                });
            })
            .catch(() => {
                this.setState({
                    isLoading: false,
                    pdfOptionsDirty: true
                });
                this.props.templateStore.openSnackbar("Failed to update PDF. Please try again.");
            });
    }

    handleUpdatePdf = () => {
        this.refreshPdfWithOptions(this.state.pdfOptions);
    }

    setPreset = (presetName) => {
        let newOptions;
        
        if (presetName === 'full') {
            newOptions = {
                includeActPhone: true,
                includeActEmail: true,
                includeActAddress: true,
                includeFeeDetails: true,
                includeVenueContract: true,
                includeAgencyContract: true
            };
        } else if (presetName === 'venue') {
            newOptions = {
                includeActPhone: true,
                includeActEmail: false,
                includeActAddress: false,
                includeFeeDetails: true,
                includeVenueContract: true,
                includeAgencyContract: false
            };
        } else if (presetName === 'minimal') {
            newOptions = {
                includeActPhone: true,
                includeActEmail: false,
                includeActAddress: false,
                includeFeeDetails: false,
                includeVenueContract: false,
                includeAgencyContract: false
            };
        }
        
        this.setState({
            pdfOptions: newOptions,
            sendFeeDetails: newOptions.includeFeeDetails,
            activePreset: presetName,
            pdfOptionsDirty: true
        });
    }

    toggleRecipients = () => {
        this.setState({
            recipientsExpanded: !this.state.recipientsExpanded
        });
    }

    toggleMobilePreview = () => {
        this.setState({
            mobilePreviewExpanded: !this.state.mobilePreviewExpanded
        });
    }

    getPresetName = () => {
        const { activePreset } = this.state;
        if (activePreset === 'full') return 'Full Details';
        if (activePreset === 'venue') return 'Venue Copy';
        if (activePreset === 'minimal') return 'Minimal';
        return 'Custom';
    }

    render() {
        const { booking, createdBy,bookingHeading } = this.props.bookingRequestStore;
        const {currentUser} = this.props.userStore
        const {clientMessage, image, isLoading, sendFeeDetails, mobilePreviewExpanded} = this.state
        return (
            <div>
                <Loading showed={isLoading} />
                <Paper style={{padding:30}}>
                    {/* Mobile Header */}
                    <div className="send-booking-mobile-header">
                        <button className="back-btn" onClick={() => this.props.history.goBack()}>
                            ←
                        </button>
                        <h1>Send Booking Details</h1>
                    </div>
                    
                    <Grid container spacing={8}>
                        <Grid item xs={12} md={5}>
                            <div>
                                <Typography variant="headline" component="h3" gutterBottom className="send-booking-desktop-title">
                                    Send Booking Details
                                </Typography>
                                <Grid container spacing={8}>
                                    <Grid item sm={12} md={12} lg={12}>
                                        <MultiInputTextbox initialInput={this.state.to} onInputsChange={(newInputs) => this.setData(newInputs)} />
                                    </Grid>
                                    <Grid item sm={12} md={12} lg={12}>
                                        <MultiInputTextboxReplyTo initialInput={this.state.replyTo} onInputsChange={(newInputs) => this.setReplyTo(newInputs)} />
                                    </Grid>
                                    <Grid item sm={12} md={12} lg={12}>
                                        <Typography gutterBottom>
                                            <b>Subject:</b> &nbsp;
                                        <input
                                            type="text"
                                            value={this.state.subject}
                                            style={{width:"100%"}}
                                            onChange={this.handleInputChangeSubject}
                                            className="multi-input-textbox"
                                        />
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={12} md={12} lg={12}>
                                        <Typography gutterBottom>
                                            <b>Message to client:</b>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} lg={12} className="gridPrivateBookingForm">
                                        {/* <TextField
                                            id="input-client-message"
                                            value={clientMessage}
                                            onChange={this.handleSetMessage}
                                            fullWidth
                                            multiline
                                            rows={10}
                                        /> */}
                                        {isLoading ? null :
                                            <RichTextEditor value={clientMessage} onChange={this.handleChangeBody}/>
                                        }
                                    </Grid>
                                    {/* PDF Options Panel */}
                                    <Grid item sm={12} md={12} lg={12}>
                                        <div className="pdf-options-panel">
                                            <div className="pdf-options-header" onClick={this.togglePdfOptions}>
                                                <div className="pdf-options-title">
                                                    <SettingsIcon style={{ color: '#ff0c9c', fontSize: 18 }} />
                                                    <span>PDF Options</span>
                                                    <span className="pdf-options-mobile-subtitle">{this.getPresetName()} selected</span>
                                                </div>
                                                <ExpandMoreIcon 
                                                    className={`pdf-options-expand-icon ${this.state.pdfOptionsExpanded ? 'expanded' : ''}`}
                                                    style={{ color: '#666' }}
                                                />
                                            </div>
                                            <Collapse in={this.state.pdfOptionsExpanded}>
                                                <div className="pdf-options-body">
                                                    {/* Preset Buttons */}
                                                    <div className="pdf-preset-buttons">
                                                        <button 
                                                            className={`pdf-preset-btn ${this.state.activePreset === 'full' ? 'active' : ''}`}
                                                            onClick={() => this.setPreset('full')}
                                                        >
                                                            Full Details
                                                        </button>
                                                        <button 
                                                            className={`pdf-preset-btn ${this.state.activePreset === 'venue' ? 'active' : ''}`}
                                                            onClick={() => this.setPreset('venue')}
                                                        >
                                                            Venue Copy
                                                        </button>
                                                        <button 
                                                            className={`pdf-preset-btn ${this.state.activePreset === 'minimal' ? 'active' : ''}`}
                                                            onClick={() => this.setPreset('minimal')}
                                                        >
                                                            Minimal
                                                        </button>
                                                    </div>

                                                    {/* Act Contact Details */}
                                                    <div className="pdf-options-group">
                                                        <div className="pdf-options-group-title">Act Contact Details</div>
                                                        <div className="pdf-options-checkbox-row">
                                                            <Checkbox
                                                                checked={this.state.pdfOptions.includeActPhone}
                                                                onChange={this.handlePdfOptionChange('includeActPhone')}
                                                                color="primary"
                                                                style={{ padding: 4 }}
                                                            />
                                                            <label>Act Phone Number</label>
                                                            <span className="pdf-options-hint">Recommended</span>
                                                            <div 
                                                                className={`mobile-toggle-switch ${this.state.pdfOptions.includeActPhone ? 'active' : ''}`}
                                                                onClick={() => this.handlePdfOptionChange('includeActPhone')({ target: { checked: !this.state.pdfOptions.includeActPhone }})}
                                                            />
                                                        </div>
                                                        <div className="pdf-options-checkbox-row">
                                                            <Checkbox
                                                                checked={this.state.pdfOptions.includeActEmail}
                                                                onChange={this.handlePdfOptionChange('includeActEmail')}
                                                                color="primary"
                                                                style={{ padding: 4 }}
                                                            />
                                                            <label>Act Email Address</label>
                                                            <div 
                                                                className={`mobile-toggle-switch ${this.state.pdfOptions.includeActEmail ? 'active' : ''}`}
                                                                onClick={() => this.handlePdfOptionChange('includeActEmail')({ target: { checked: !this.state.pdfOptions.includeActEmail }})}
                                                            />
                                                        </div>
                                                        <div className="pdf-options-checkbox-row">
                                                            <Checkbox
                                                                checked={this.state.pdfOptions.includeActAddress}
                                                                onChange={this.handlePdfOptionChange('includeActAddress')}
                                                                color="primary"
                                                                style={{ padding: 4 }}
                                                            />
                                                            <label>Act Street Address</label>
                                                            <div 
                                                                className={`mobile-toggle-switch ${this.state.pdfOptions.includeActAddress ? 'active' : ''}`}
                                                                onClick={() => this.handlePdfOptionChange('includeActAddress')({ target: { checked: !this.state.pdfOptions.includeActAddress }})}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="pdf-options-divider"></div>

                                                    {/* Financial Details */}
                                                    <div className="pdf-options-group">
                                                        <div className="pdf-options-group-title">Financial Details</div>
                                                        <div className="pdf-options-checkbox-row">
                                                            <Checkbox
                                                                checked={this.state.pdfOptions.includeFeeDetails}
                                                                onChange={this.handlePdfOptionChange('includeFeeDetails')}
                                                                color="primary"
                                                                style={{ padding: 4 }}
                                                            />
                                                            <label>Include Fee Details</label>
                                                            <div 
                                                                className={`mobile-toggle-switch ${this.state.pdfOptions.includeFeeDetails ? 'active' : ''}`}
                                                                onClick={() => this.handlePdfOptionChange('includeFeeDetails')({ target: { checked: !this.state.pdfOptions.includeFeeDetails }})}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="pdf-options-divider"></div>

                                                    {/* Contracts */}
                                                    <div className="pdf-options-group">
                                                        <div className="pdf-options-group-title">Contracts</div>
                                                        <div className="pdf-options-checkbox-row">
                                                            <Checkbox
                                                                checked={this.state.pdfOptions.includeVenueContract}
                                                                onChange={this.handlePdfOptionChange('includeVenueContract')}
                                                                color="primary"
                                                                style={{ padding: 4 }}
                                                            />
                                                            <label>Venue Contract</label>
                                                            <div 
                                                                className={`mobile-toggle-switch ${this.state.pdfOptions.includeVenueContract ? 'active' : ''}`}
                                                                onClick={() => this.handlePdfOptionChange('includeVenueContract')({ target: { checked: !this.state.pdfOptions.includeVenueContract }})}
                                                            />
                                                        </div>
                                                        <div className="pdf-options-checkbox-row">
                                                            <Checkbox
                                                                checked={this.state.pdfOptions.includeAgencyContract}
                                                                onChange={this.handlePdfOptionChange('includeAgencyContract')}
                                                                color="primary"
                                                                style={{ padding: 4 }}
                                                            />
                                                            <label>Agency Contract</label>
                                                            <span className="pdf-options-hint">Usually not needed</span>
                                                            <div 
                                                                className={`mobile-toggle-switch ${this.state.pdfOptions.includeAgencyContract ? 'active' : ''}`}
                                                                onClick={() => this.handlePdfOptionChange('includeAgencyContract')({ target: { checked: !this.state.pdfOptions.includeAgencyContract }})}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Collapse>
                                            {this.state.pdfOptionsDirty && (
                                                <div style={{ padding: '8px 16px 4px', textAlign: 'right' }}>
                                                    <Button 
                                                        variant="raised" 
                                                        color="primary" 
                                                        onClick={this.handleUpdatePdf}
                                                        disabled={this.state.isLoading}
                                                        style={{ fontSize: 13 }}
                                                    >
                                                        {this.state.isLoading ? 'Updating...' : 'Update PDF'}
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    </Grid>
                                    <Grid item sm={12} md={12} lg={12}>
                                        <Button variant="raised" color="primary" onClick={this.handleSubmitForm} className="desktop-send-button">
                                            Send
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                        {/* Gmail-Style Email Preview */}
                        <Grid item xs={12} lg={7}>
                            {/* Mobile Preview Toggle */}
                            <div className="mobile-preview-toggle">
                                <button className="mobile-preview-toggle-btn" onClick={this.toggleMobilePreview}>
                                    <div className="mobile-preview-toggle-left">
                                        <div className="mobile-preview-icon">
                                            <EmailIcon style={{ fontSize: 18 }} />
                                        </div>
                                        <div>
                                            <div className="mobile-preview-title">Email Preview</div>
                                            <div className="mobile-preview-subtitle">Tap to {mobilePreviewExpanded ? 'collapse' : 'expand'}</div>
                                        </div>
                                    </div>
                                    <ExpandMoreIcon className={`mobile-preview-chevron ${mobilePreviewExpanded ? 'expanded' : ''}`} />
                                </button>
                                
                                {/* Mini Preview - shown when collapsed */}
                                <div className={`mobile-mini-preview ${mobilePreviewExpanded ? 'hidden' : ''}`}>
                                    <div className="mobile-mini-preview-avatar">
                                        {createdBy ? createdBy.firstName?.charAt(0).toUpperCase() : 'H'}
                                    </div>
                                    <div className="mobile-mini-preview-info">
                                        <div className="mobile-mini-preview-subject">{this.state.subject || 'Booking Details'}</div>
                                        <div className="mobile-mini-preview-to">To: {this.state.to.length > 0 ? this.state.to[0] : 'recipient'}</div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className={`email-preview-container ${mobilePreviewExpanded ? 'mobile-expanded' : 'mobile-collapsed'}`}>
                                {/* Dark Header Bar */}
                                <div className="email-preview-header">
                                    <div className="email-preview-header-title">
                                        <EmailIcon style={{ fontSize: 18 }} />
                                        Email Preview
                                    </div>
                                    <div className="email-preview-actions">
                                        <button className="preview-action-btn" title="Print">
                                            <PrintIcon style={{ fontSize: 16 }} />
                                        </button>
                                        <button className="preview-action-btn" title="Expand">
                                            <OpenInNewIcon style={{ fontSize: 16 }} />
                                        </button>
                                    </div>
                                </div>

                                {/* Subject Bar */}
                                <div className="email-subject-bar">
                                    <h3 className="email-subject-text">{this.state.subject}</h3>
                                </div>

                                {/* Sender Row */}
                                <div className="email-sender-row">
                                    <div className="sender-avatar">
                                        {createdBy ? createdBy.firstName?.charAt(0).toUpperCase() : 'H'}
                                    </div>
                                    <div className="sender-info">
                                        <div className="sender-name-row">
                                            <span className="sender-name">
                                                {createdBy ? `${createdBy.firstName} ${createdBy.lastName}` : 'Hot Giggity'}
                                            </span>
                                            <span className="sender-email">&lt;no-reply@hotgiggity.com&gt;</span>
                                        </div>
                                        <div className="recipient-row">
                                            to {this.state.to.length > 0 ? this.state.to[0] : 'recipient'}
                                            {this.state.to.length > 1 && (
                                                <span 
                                                    className={`recipient-toggle ${this.state.recipientsExpanded ? 'expanded' : ''}`}
                                                    onClick={this.toggleRecipients}
                                                >
                                                    +{this.state.to.length - 1} more ▼
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <span className="email-timestamp">{moment().format('MMM D, h:mm A')}</span>
                                </div>

                                {/* Expanded Recipients */}
                                <Collapse in={this.state.recipientsExpanded}>
                                    <div className="recipients-expanded">
                                        <div className="recipient-line">
                                            <span className="recipient-label">From:</span>
                                            <span className="recipient-value">
                                                {createdBy ? `${createdBy.firstName} ${createdBy.lastName}` : 'Hot Giggity'} &lt;no-reply@hotgiggity.com&gt;
                                            </span>
                                        </div>
                                        <div className="recipient-line">
                                            <span className="recipient-label">To:</span>
                                            <span className="recipient-value">{this.state.to.join(', ')}</span>
                                        </div>
                                        <div className="recipient-line">
                                            <span className="recipient-label">Reply-To:</span>
                                            <span className="recipient-value">{this.state.replyTo.join(', ')}</span>
                                        </div>
                                    </div>
                                </Collapse>

                                {/* Email Body */}
                                <div className="email-body-wrapper">
                                    {/* Hero Section with Background */}
                                    <div 
                                        className="email-hero-section"
                                        style={{ 
                                            backgroundImage: `url(${image?.backgroundImage?.length ? image?.backgroundImage[0].url : blankBackground})`
                                        }}
                                    >
                                        <div className="profile-avatar-large">
                                            <img 
                                                src={image?.profileImage ? image?.profileImage?.url400 : blankProfile} 
                                                alt="Profile"
                                            />
                                        </div>
                                    </div>

                                    {/* Message Content */}
                                    <div 
                                        className="email-message-content"
                                        dangerouslySetInnerHTML={{ __html: clientMessage !== "" ? clientMessage : '<p style="color: #999;">Your message will appear here...</p>' }}
                                    />

                                    {/* Attachment Section */}
                                    <div className="attachments-section">
                                        <div className="attachments-header">
                                            <AttachFileIcon style={{ fontSize: 14 }} />
                                            1 Attachment
                                        </div>
                                        <div 
                                            className="attachment-card"
                                            onClick={() => this.setState({ openDetails: true })}
                                        >
                                            <div className="attachment-icon">PDF</div>
                                            <div className="attachment-info">
                                                <div className="attachment-name">
                                                    {booking.title}-{moment(booking.dateStart).format("ddd, DD-MM-YYYY")}.pdf
                                                </div>
                                                <div className="attachment-meta">Booking Details • Click to preview</div>
                                            </div>
                                            <div className="attachment-actions">
                                                <button 
                                                    className="attachment-action-btn" 
                                                    title="Preview"
                                                    onClick={(e) => { e.stopPropagation(); this.setState({ openDetails: true }); }}
                                                >
                                                    <VisibilityIcon style={{ fontSize: 18 }} />
                                                </button>
                                                <button 
                                                    className="attachment-action-btn" 
                                                    title="Download"
                                                    onClick={(e) => { e.stopPropagation(); }}
                                                >
                                                    <GetAppIcon style={{ fontSize: 18 }} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    {/* <Grid style={{marginTop:20}} container spacing={8}>
                        <Grid item xs={12} lg={12} style={{ border: 2, borderColor: "gray", borderStyle: "solid", paddingLeft: 15, paddingBottom: 15 }}>
                            <PdfViewer file={this.state.pdfFile}/>
                        </Grid>
                    </Grid> */}
                    
                    {/* Mobile Bottom Spacer */}
                    <div className="mobile-bottom-spacer"></div>
                </Paper>
                
                {/* Mobile Fixed Send Button */}
                <div className="mobile-send-button-container">
                    <button className="mobile-send-button" onClick={this.handleSubmitForm}>
                        <EmailIcon style={{ fontSize: 18 }} />
                        Send Email
                    </button>
                </div>
                <BookingDetailsModal
                        open={this.state.openDetails}
                        title={`${booking.title} ${moment(booking.dateStart).format("ddd, DD-MM-YYYY")} ${moment(booking.timeStart, "HH:mm").format("h.mma")}`}
                        maxWidth="lg"
                        clientInvoice={false}
                        pdfFile={this.state.pdfFile}
                        closeHandler={e => this.setState({ openDetails: false })}
                        bookingId={this.props.bookingId} 
                        sendFeeDetails={this.state.sendFeeDetails}
                        pdfOptions={this.state.pdfOptions}
                    />
            </div>
        );
    }
}

export default SendBookingDetailsComponent;
